/* eslint-disable no-unused-vars */
import React, { createContext } from "react";
const VideoContext = createContext();

export default VideoContext;
